import React from 'react';

const Map = () => {
    return (
        <div className='map-container' style={{ width: '100%', height: '400px', overflow: 'hidden' }}>
            <iframe
                 src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14235.026238032586!2d80.9662262!3d26.8794745!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bfd0071c2dec3%3A0xa8db72b300156256!2sHope%20Rise%20Multi-speciality%20Hospital%2C%20Lucknow!5e0!3m2!1sen!2sin!4v1731483171462!5m2!1sen!2sin"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Map of Hope Hospital"
            ></iframe>
        </div>
    );
};

export default Map;
